import { useRecoilState } from "recoil";
import formInfoAtom from "./atom";

const useFormInfo = () => useRecoilState(formInfoAtom);
export default useFormInfo;
